module.exports = __webpack_public_path__ + "img/g0038.b06b73a6.png";